import { jsx } from "panel";
import { ContextPanelMenuEl } from "common/widgets/context-panel/context-panel-menu";
import { PositioningStrategy } from "../drop-menu/types";
import { DropMenuEl } from "../drop-menu";
import { SectionEl, SectionRowEl } from "./section";
import { SectionItemEl, SectionItemSubMenuEl } from "./section/item";
const EmptySearchResult = ({
  message
}) => /* @__PURE__ */ jsx("ul", { sel: ".screen-options-list", "data-sentry-component": "EmptySearchResult", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("li", { sel: ".list-option.list-empty" }, /* @__PURE__ */ jsx("div", { sel: ".option-label" }, message)));
const SectionList = ({
  comp,
  sections
}) => {
  const sectionsHint = comp.attr(`sections-hint`);
  const searchFilter = comp.attr(`search-filter`);
  const alignAllText = comp.attr(`align-all-text`) && sections.some((section) => section.iconRenderer || section.items.some((item) => {
    var _a;
    return (_a = item.wrapped) == null ? void 0 : _a.iconRenderer;
  }));
  const showMatches = !comp.attr(`disable-search-filter-matching-parts`);
  const {
    focusedItemIndex,
    isPillFocused,
    fullyShownSections
  } = comp.state;
  const {
    contextPanelTransform
  } = comp;
  const hasContextPanelContentSlot = comp.helpers.hasSlot(`context-panel-content`);
  let sectionsEl;
  if (sections.length) {
    sectionsEl = /* @__PURE__ */ jsx(null, null, sectionsHint && /* @__PURE__ */ jsx("div", { sel: ".sections-hint" }, sectionsHint), sections.map((section, idx) => {
      var _a;
      return /* @__PURE__ */ jsx(SectionEl, { section, sectionIdx: idx, hideSectionTitle: section.isHidden && !fullyShownSections[section.sectionIndex] || Boolean(section.expansionToggle), areSectionItemsHidden: (section.isHidden || Boolean(section.expansionToggle)) && !fullyShownSections[section.sectionIndex], numOriginalItems: ((_a = comp.state.sections[section.sectionIndex]) == null ? void 0 : _a.items.length) || 0, i18n: comp.getContext(`i18n`) }, section.items.map((item) => {
        var _a2, _b;
        const sectionItem = item.wrapped;
        const isFocused = focusedItemIndex === item.index;
        const isItemSubMenuOpen = comp.isSubItemsOpen(item.index);
        const selectedTheme = section.selectedTheme && comp.getSelectedTheme(section.selectedTheme) || comp.getSelectedTheme();
        return /* @__PURE__ */ jsx(SectionRowEl, { allowPointerEventsAlways: hasContextPanelContentSlot, i18n: comp.getContext(`i18n`), item, isFocused, selectedTheme, contextPanelTransform, onClick: comp.helpers.handleClickItem, onMouseEnter: comp.helpers.handleMouseEnterItem }, /* @__PURE__ */ jsx(SectionItemEl, { item, theme: comp.attr(`theme`), isPillFocused, selectedTheme, checkboxIcon: comp.attr(`checkbox-icon`), isFocused, alignAllText, showMatches, actionsRenderer: (_a2 = sectionItem.actionsRenderer) != null ? _a2 : section.actionsRenderer, iconRenderer: (_b = sectionItem.iconRenderer) != null ? _b : section.iconRenderer, onActionClick: comp.helpers.handleClickPill, onActionMouseEnter: comp.helpers.handleMouseEnterPill, onActionMouseLeave: comp.helpers.handleMouseLeavePill, fullyShownSections: comp.state.fullyShownSections, i18n: comp.getContext(`i18n`) }), isItemSubMenuOpen && (sectionItem.subMenuRenderer ? sectionItem.subMenuRenderer((selectedValue, additionalInfo) => {
          const itemClickEvent = comp.getClickItemEvent({
            item: {
              ...item,
              wrapped: {
                ...item.wrapped,
                value: selectedValue,
                additionalInfo
              }
            },
            modifierKeys: null
          });
          comp.helpers.handleSubItemsClickItem(itemClickEvent);
        }, comp) : /* @__PURE__ */ jsx(SectionItemSubMenuEl, { sections: sectionItem.subSections, alignAllText: comp.attr(`align-all-text`), selectedTheme, contextPanelTransform, keydownProxyEl: comp.keydownProxyEl || comp, onNavigateBack: comp.helpers.handleSubItemsNavigateBack, onClickItem: comp.helpers.handleSubItemsClickItem, onFocusItem: comp.helpers.propagateEvent, onMouseEnter: comp.helpers.handleSubMenuMouseEnter, theme: comp.attr(`sub-menu-theme`) })));
      }));
    }));
  }
  let emptyMessageEl;
  if (comp.getFilledSections(sections, {
    excludeAlwaysShowLabel: true
  }).length === 0) {
    if (searchFilter) {
      emptyMessageEl = /* @__PURE__ */ jsx(EmptySearchResult, { message: comp.attr(`empty-search-results-message`) });
    } else {
      emptyMessageEl = /* @__PURE__ */ jsx(EmptySearchResult, { message: comp.attr(`empty-message`) });
    }
  }
  return /* @__PURE__ */ jsx(null, null, sectionsEl, emptyMessageEl);
};
export function Template() {
  const {
    tooltipData
  } = this.state;
  const hasContextPanelContentSlot = this.helpers.hasSlot(`context-panel-content`);
  const sections = this.helpers.getDisplaySections();
  return /* @__PURE__ */ jsx("div", { sel: ".items-menu", hook: {
    postpatch: this.helpers.handlePostPatch
  }, class: {
    [`${this.attr(`theme`)}-theme`]: true,
    "disable-first-item-padding": this.attr(`disable-first-item-padding`)
  }, "data-sentry-component": "Template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".screen-list-container", class: {
    "has-sections": sections.length > 0
  }, on: {
    scroll: this.helpers.handleScroll,
    mouseleave: () => this.helpers.handleMouseLeave(),
    mouseenter: () => this.debouncedUnFocusItem.cancel()
  }, hook: {
    insert: ({
      elm
    }) => this.handleInsertScreenListContainer(elm)
  } }, /* @__PURE__ */ jsx(SectionList, { comp: this, sections, "data-sentry-element": "SectionList", "data-sentry-source-file": "template.tsx" })), tooltipData && /* @__PURE__ */ jsx(ContextPanelMenuEl, { attrs: {
    elref: `contextPanel`,
    placement: this.attr(`context-panel-alignment`),
    "project-is-free-plan": this.attr(`project-is-free-plan`)
  }, params: {
    data: tooltipData,
    positionParent: this.contextPanelPositionParentElement
  } }), hasContextPanelContentSlot && /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    direction: this.attr(`context-panel-alignment`),
    offset: -8,
    skidding: 72,
    open: true,
    "position-strategy": PositioningStrategy.Absolute
  }, props: {
    positionParent: this.contextPanelPositionParentElement
  } }, /* @__PURE__ */ jsx("slot", { attrs: {
    name: `context-panel-content`
  } })));
}
